module.exports = __webpack_public_path__ + "static/shoe-grip-0bbbab981cd682d1453b0162340ee61a.png";